import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { ToastProvider } from './components/ui/Toast';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminPrivateRoute from './components/admin/AdminPrivateRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import SignatureListPage from './pages/SignatureListPage';
import SignatureSettingsPage from './pages/SignatureSettingsPage';
import SignatureCalendarPage from './pages/SignatureCalendarPage';
import DashboardPage from './pages/DashboardPage';
import TemplateLibraryPage from './pages/TemplateLibraryPage';
import TemplateVersionsPage from './pages/TemplateVersionsPage';
import OrganizationSettingsPage from './pages/OrganizationSettingsPage';
import DirectorySettingsPage from './pages/DirectorySettingsPage';
import StatisticsPage from './pages/StatisticsPage';
// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOrganizations from './pages/admin/AdminOrganizations';
import AdminOrganizationDetail from './pages/admin/AdminOrganizationDetail';
import AdminServerHealth from './pages/admin/AdminServerHealth';
import AdminTemplates from './pages/admin/AdminTemplates';
import AdminTemplateBuilder from './pages/admin/AdminTemplateBuilder';
import AdminLogs from './pages/admin/AdminLogs';
import './App.css';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
            <OrganizationProvider>
            <ToastProvider>
                <Routes>
                    {/* Routes publiques */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />

                    {/* Routes protégées */}
                    <Route
                        path="/signatures"
                        element={
                            <PrivateRoute>
                                <SignatureListPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/signatures/:id/settings"
                        element={
                            <PrivateRoute>
                                <SignatureSettingsPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/signatures/calendar"
                        element={
                            <PrivateRoute>
                                <SignatureCalendarPage />
                            </PrivateRoute>
                        }
                    />

                    {/* Routes Templates */}
                    <Route
                        path="/templates"
                        element={
                            <PrivateRoute>
                                <TemplateLibraryPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/templates/new"
                        element={
                            <PrivateRoute>
                                <DashboardPage mode="template" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/templates/edit/:id"
                        element={
                            <PrivateRoute>
                                <DashboardPage mode="template" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/templates/:id/versions"
                        element={
                            <PrivateRoute>
                                <TemplateVersionsPage />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/builder"
                        element={
                            <PrivateRoute>
                                <DashboardPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <PrivateRoute>
                                <ProfilePage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/organization/settings"
                        element={
                            <PrivateRoute>
                                <OrganizationSettingsPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/directory"
                        element={
                            <PrivateRoute>
                                <DirectorySettingsPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/statistics"
                        element={
                            <PrivateRoute>
                                <StatisticsPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/statistics/:id"
                        element={
                            <PrivateRoute>
                                <StatisticsPage />
                            </PrivateRoute>
                        }
                    />

                    {/* Routes Admin */}
                    <Route
                        path="/admin/*"
                        element={
                            <AdminAuthProvider>
                                <Routes>
                                    <Route path="login" element={<AdminLoginPage />} />
                                    <Route
                                        path="dashboard"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminDashboard />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="organizations"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminOrganizations />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="organizations/:id"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminOrganizationDetail />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="server"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminServerHealth />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="templates"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminTemplates />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="templates/new"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminTemplateBuilder />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="templates/:id/edit"
                                        element={
                                            <AdminPrivateRoute>
                                                <AdminTemplateBuilder />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="logs"
                                        element={
                                            <AdminPrivateRoute requireSuperAdmin>
                                                <AdminLogs />
                                            </AdminPrivateRoute>
                                        }
                                    />
                                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                                </Routes>
                            </AdminAuthProvider>
                        }
                    />

                    {/* Redirection par défaut */}
                    <Route path="/" element={<Navigate to="/signatures" replace />} />
                    <Route path="*" element={<Navigate to="/signatures" replace />} />
                </Routes>
            </ToastProvider>
            </OrganizationProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
